export const getBase64ImageByUrl = (
  url,
  format = 'image/jpeg',
  quality = 0.92
) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'Anonymous';
    image.onload = function () {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth || image.width;
        canvas.height = image.naturalHeight || image.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0);

        const supportsQuality =
          format === 'image/jpeg' || format === 'image/webp';
        const dataURL = supportsQuality
          ? canvas.toDataURL(format, quality)
          : canvas.toDataURL(format);

        const base64 = dataURL.replace(
          /^data:image\/(png|jpg|jpeg|webp);base64,/,
          ''
        );
        resolve(base64);
      } catch (err) {
        reject(err);
      }
    };
    image.onerror = function () {
      reject(new Error(`Cannot load image: ${url}`));
    };
    image.src = url;
  });
};
